(function () {
  function initialize(root) {
    const config = root.querySelector('[data-mono-offer-test]');
    const pickerUi = root.querySelector('[data-mono-offer-test-picker]');
    const productPicker = root.querySelector('.product-picker');

    if (!config || !pickerUi || !productPicker || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';

    const sourcePacks = Array.from(productPicker.querySelectorAll(':scope > .product-picker-packs .product-picker-pack'));
    const testPacks = Array.from(pickerUi.querySelectorAll('[data-mono-pack]'));
    const testPackButtons = Array.from(pickerUi.querySelectorAll('[data-mono-pack-button]'));
    const sourceSubscription = productPicker.querySelector(':scope > .product-picker-variants .product-picker-subs');
    const sourceOtp = productPicker.querySelector(':scope > .product-picker-variants .product-picker-otp');
    const addToCartButton = root.querySelector('.product-info-btn');
    const sourceGiftList = sourceSubscription?.querySelector('.product-picker-variant__list');
    const otpButton = config.querySelector('[data-mono-otp]');
    const otpPrice = config.querySelector('[data-mono-otp-price]');
    const detachedTitle = config.querySelector('[data-mono-detached-title]');
    const detachedSubtitle = config.querySelector('[data-mono-detached-subtitle]');
    const detachedList = config.querySelector('[data-mono-detached-list]');
    const refillFrequency = config.querySelector('[data-mono-refill-frequency]');
    const offerType = config.dataset.offerType || pickerUi.dataset.offerType || 'mono';
    const sourceOtpPrice = sourceOtp?.querySelector('.product-picker-variant__price--new');
    const formatTabs = Array.from(root.querySelectorAll('.electrolytes-format-tab'));

    const giftTotalsByOffer = {
      mono: { 1: 58, 2: 78, 3: 131 },
      powder: { 1: 55, 2: 70, 3: 83 },
      magnesium: { 1: 43, 2: 58, 3: 58 },
      electrolytes: { 1: 43, 2: 58, 3: 78 },
    };
    const giftTotals = giftTotalsByOffer[offerType] || giftTotalsByOffer.mono;
    const monoOtpPrices = { 1: '$59', 2: '$99', 3: '$145' };
    const refillFrequencies = {
      1: 'Refills every month',
      2: 'Refills every 2 months',
      3: 'Refills every 3 months',
    };
    const giftImages = [
      ['magnesium+ gummies', '/cdn/shop/files/main-image-orange2_1500x1500px.png?v=16775328803456470728'],
      ['electrolyte', '/cdn/shop/files/MAG_3_2_1.webp?v=12670507446732404610'],
      ['water bottle', '/cdn/shop/files/bottle-no-bg.webp?v=6198394243305638386'],
      ['4-gummy travel case', '/cdn/shop/files/case_1.png?v=2922415388674172588'],
      ['longevity guide for men', '/cdn/shop/files/Web_Cover_Men_2.webp?v=3280547066975137999'],
      ['longevity guide for women', '/cdn/shop/files/Web_Cover_Women_2.webp?v=3090032653186482632'],
      ['shipping', '/cdn/shop/files/ship-icon-no-bg.webp?v=7896262239521943904'],
    ];

    function getActivePackNumber() {
      const activeIndex = sourcePacks.findIndex((pack) => pack.classList.contains('active'));
      return activeIndex >= 0 ? activeIndex + 1 : 1;
    }

    function replaceGiftImage(item) {
      const image = item.querySelector('img');
      if (!image) return;

      if (offerType === 'mono') {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      }
      const giftLabel = `${image.alt || ''} ${item.textContent || ''}`.trim().toLowerCase();
      if (offerType === 'mono' && String(image.getAttribute('src') || '').includes('/menu-mag-mb.webp')) return;
      const giftImage = giftImages.find(([name]) => giftLabel.includes(name));
      if (!giftImage) return;

      if (offerType === 'mono') {
        const urlAtHeight = (height) => {
          const url = new URL(giftImage[1], window.location.href);
          url.searchParams.set('height', String(height));
          return url.href;
        };
        image.srcset = `${urlAtHeight(50)} 1x, ${urlAtHeight(100)} 2x, ${urlAtHeight(150)} 3x`;
        image.src = urlAtHeight(50);
        image.removeAttribute('sizes');
      } else {
        image.src = giftImage[1];
        image.removeAttribute('srcset');
      }
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
    }

    function getOtpPrice(packNumber) {
      if (offerType !== 'mono') {
        const currentSourcePrice = sourceOtpPrice?.textContent?.trim();
        return currentSourcePrice || '…';
      }

      return monoOtpPrices[packNumber] || '';
    }

    function syncOfferVisibility() {
      const activeFormat = formatTabs.find((tab) => tab.classList.contains('active'))?.dataset.format;
      root.classList.toggle(
        'mono-offer-test--source-picker-visible',
        offerType === 'electrolytes' && activeFormat === 'tube'
      );
    }

    function cloneGiftContent(packNumber) {
      if (!sourceGiftList) return;

      testPacks.forEach((pack) => {
        const mount = pack.querySelector('[data-mono-inline-gifts]');
        if (mount) mount.replaceChildren();
      });

      const activePack = testPacks[packNumber - 1];
      const inlineMount = activePack?.querySelector('[data-mono-inline-gifts]');

      if (inlineMount) {
        Array.from(sourceGiftList.children).forEach((child) => {
          const clone = child.cloneNode(true);
          if (clone.classList.contains('product-picker-variant__list__title')) {
            clone.textContent = `+Free gifts with your first order ($${giftTotals[packNumber]} total value):`;
          }
          replaceGiftImage(clone);
          inlineMount.appendChild(clone);
        });
      }

      if (detachedList) {
        detachedList.replaceChildren();
        sourceGiftList.querySelectorAll('.product-picker-variant__list__item').forEach((item) => {
          const clone = item.cloneNode(true);
          replaceGiftImage(clone);
          detachedList.appendChild(clone);
        });
      }

      if (detachedTitle) {
        const subscriptionQuantity =
          offerType === 'electrolytes'
            ? `${packNumber}-${packNumber === 1 ? 'MONTH' : 'MONTHS'}`
            : `${packNumber}-PACK`;
        detachedTitle.textContent = `FREE GIFTS WITH YOUR ${subscriptionQuantity} SUBSCRIPTION`;
      }
      if (detachedSubtitle) {
        detachedSubtitle.textContent = `$${giftTotals[packNumber]} total value. Arrive with your first order`;
      }
    }

    function sync() {
      syncOfferVisibility();
      const packNumber = getActivePackNumber();
      testPacks.forEach((pack, index) => {
        const isActive = index === packNumber - 1;
        pack.classList.toggle('is-active', isActive);
        pack.querySelector('[data-mono-pack-button]')?.setAttribute('aria-pressed', String(isActive));
      });

      if (otpPrice) otpPrice.textContent = getOtpPrice(packNumber);
      if (refillFrequency) refillFrequency.textContent = refillFrequencies[packNumber];
      if (otpButton && offerType !== 'powder') {
        otpButton.setAttribute('aria-pressed', String(sourceOtp?.classList.contains('active')));
      }
      cloneGiftContent(packNumber);
    }

    function scheduleSync() {
      window.setTimeout(sync, 0);
      window.setTimeout(sync, 50);
    }

    testPackButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        sourcePacks[index]?.click();
        if (!sourceSubscription?.classList.contains('active')) sourceSubscription?.click();
        scheduleSync();
      });
    });

    formatTabs.forEach((tab) => tab.addEventListener('click', scheduleSync));

    otpButton?.addEventListener('click', () => {
      if (offerType === 'powder') {
        // Buy once is an action; the displayed powder offer stays subscribed.
        addToCartButton?.dispatchEvent(new CustomEvent('product-picker:buy-once'));
        return;
      }
      sourceOtp?.click();
      window.setTimeout(() => addToCartButton?.click(), 0);
    });

    if (sourceGiftList) {
      const giftObserver = new MutationObserver(scheduleSync);
      giftObserver.observe(sourceGiftList, { childList: true, subtree: true, characterData: true });
    }

    if (sourceOtp) {
      const otpObserver = new MutationObserver(scheduleSync);
      otpObserver.observe(sourceOtp, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['class'],
      });
    }

    const packWrap = productPicker.querySelector(':scope > .product-picker-packs');
    if (packWrap) {
      const packObserver = new MutationObserver(scheduleSync);
      packObserver.observe(packWrap, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    scheduleSync();
  }

  document.querySelectorAll('.product-info.mono-offer-test--gifts-v1').forEach(initialize);
})();
